import { render, staticRenderFns } from "./InvoiceSurchargesTable.vue?vue&type=template&id=e6db6858&"
import script from "./InvoiceSurchargesTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceSurchargesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports